var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mr-widget-body mr-state-locked media"},[_c('status-icon',{attrs:{"status":"loading"}}),_vm._v(" "),_c('div',{staticClass:"media-body",attrs:{"data-testid":"merging-state"}},[_c('bold-text',{attrs:{"message":_vm.mergeStatus.message}}),_vm._v(" "),_c('gl-emoji',{attrs:{"data-name":_vm.mergeStatus.emoji}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }